//
// Upleap (estate-a: same backend platform as Kicksta and Buzzoid) — Bearer user search.
//   GET https://api.upleap.com/api/v1/instagram/search?context=user&query=<q>   Authorization: Bearer <token>
// Login: POST /api/v1/oauth/login { username, password } -> { status: 'ok', token } (same shape as its siblings).
// Credentials: SOCIAL_PROV_UPLEAP_EMAIL / _PASSWORD, else the existing UPLEAP_LOGIN_EMAIL / _PASSWORD; without
// either the router skips the lane. Search only: the profile endpoint serves months-old cached copies
// (see isStaleUpleapProfile in UpleapAPI.ts), so profiles stay off this lane. Separate from the legacy
// UpleapAPI strategy, which keeps its own Redis-cached token.
//

import { browserHeaders, parseIgUserSearch } from '../../router/shapes';
import type { Provider, TokenAuthConfig } from '../../router/registry';
import { KICKSTA_TOKEN_AUTH } from './Kicksta';

const HOST = 'https://api.upleap.com';

export const UPLEAP_TOKEN_AUTH: TokenAuthConfig = {
	...KICKSTA_TOKEN_AUTH,
	loginUrl: `${HOST}/api/v1/oauth/login`,
};

export const Upleap: Provider = {
	id: 'upleap',
	platform: 'instagram',
	capabilities: ['search_users'],
	family: 'estate-a',
	transport: 'bearer',
	requiresToken: true,
	seedLatencyMs: 1600, // estimate, not measured
	tokenAuth: UPLEAP_TOKEN_AUTH,
	request: (req) => ({
		url: `${HOST}/api/v1/instagram/search?context=user&query=${encodeURIComponent(req.query)}`,
		init: {
			method: 'GET',
			headers: browserHeaders({ Authorization: `Bearer ${req.token}`, Origin: 'https://upleap.com' }),
		},
	}),
	parser: (body, req) => parseIgUserSearch(body, req.limit),
};

export default Upleap;
